import React, { Component } from "react"
import { GlobalContainer, GlobalSection } from "./GlobalStyle"
import Image from "./Image"
import styled from "styled-components"

const StyledPerks = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const StyledPerkItem = styled.div`
  background-color: #fff;
  padding: 70px 15px;
  width: calc(100% / 4 - 30px);
  margin: 30px 15px 0;
  text-align: center;
  @media (max-width: 1600px) {
    padding: 30px 15px;
  }
  @media (max-width: 1200px) {
    width: calc(100% / 3 - 30px);
  }
  @media (max-width: 900px) {
    width: calc(100% / 2 - 30px);
  }
  @media (max-width: 600px) {
    width: 100%;
    margin: 30px 0 0;
  }
  &:first-of-type {
    background-color: transparent;
    text-align: left;
    padding: 0;
    h2 {
      font-size: 60px;
      font-weight: 400;
      line-height: 1em;
      @media (max-width: 1600px) {
        font-size: 40px;
      }
      &:after {
        content: '';
        display: block;
        position: relative;
        width: 100px;
        height: 2px;
        background-color: var(--main);
        margin: 20px 0;
      }
    }
    p {
      opacity: .7;
      @media (max-width: 1600px) {
        font-size: 15px;
        line-height: 1.5em;
      }
    }
  }
`
const StyledPerkItemIcon = styled.div`
  height: 80px !important;
  width: 80px !important;
  margin: 0 auto 20px;
  img {
    height: 80px !important;
  }
    @media (max-width: 1600px) {
      height: 48px !important;
      width: 48px !important;
      img {
        height: 48px !important;
      }
    }
`
const StyledPerkItemTitle = styled.div`
  font-weight: 800;
  font-size: 30px;
  word-wrap: break-spaces;
  margin-top: 8px;
  line-height: 1.4em;
  @media (max-width: 1600px) {
    font-size: 24px;
  }
`
const StyledPerkItemDescription = styled.div`
  padding: 12px 0;
  font-size: 16px;
  font-weight: 400;
  opacity: .7;
    @media (max-width: 1600px) {
      font-size: 15px;
      line-height: 1.5em;
    }
  }
`

const perks = [
  {
    id: 1,
    delay: "300",
    icon: "router",
    name: "Free 5G WiFi",
    description: "Szybka i bezpieczna sieć internetowa",
  },
  {
    id: 2,
    delay: "200",
    icon: "locker",
    name: "Własna szafka",
    description: "Możesz zostawić w niej wszystkie najpotrzebniejsze rzeczy do pracy",
  },
  {
    id: 3,
    delay: "300",
    icon: "kitchen",
    name: "Kuchnia",
    description: "Wypijesz tu przepyszną kawę z ekspresu i zjesz lunch ze współpracownikami",
  },
  {
    id: 4,
    delay: "400",
    icon: "bicycle",
    name: "Parking dla rowerów",
    description: "Na terenie biura dostępnych jest 10 miejsc parkingowych dla twojego jednośladu!",
  },
  {
    id: 5,
    delay: "500",
    icon: "chill",
    name: "Chillout room",
    description: "Pokój, w którym szybko zregenerujesz siły aby wrócić do pracy z jeszcze lepszymi pomysłami",
  },
  {
    id: 6,
    delay: "600",
    icon: "printer",
    name: "Wyposażenie biura",
    description: "Do Twojej dyspozycji jest sprzęt multimedialny w salkach konferencyjnych oraz sprzęt biurowy (skaner, drukarka, ksero)",
  },
  {
    id: 7,
    delay: "700",
    icon: "projector",
    name: "Sala szkoleniowa",
    description: "Planując szkolenie dla swojego zespołu pamiętaj, że dysponujemy salą, która pomieści wszystkich Twoich pracowników ",
  },
  {
    id: 8,
    delay: "800",
    icon: "security-camera",
    name: "Monitoring",
    description: "Twój sprzęt i rzeczy są u nas bezpieczne, dzięki monitoringowi",
  },
  {
    id: 9,
    delay: "800",
    icon: "shower",
    name: "Prysznic dla rowerzystów",
    description: "Będziesz mógł się odświeżyć po aktywności rowerowej",
  },
  {
    id: 10,
    delay: "800",
    icon: "bucket",
    name: "Codzienny serwis sprzątający",
    description: "Każdego dnia będziesz pracował w czystym biurze",
  }
]

class LandingPerks extends Component {
  render() {
    return (
      <GlobalSection bg={"var(--gray)"}>
        <GlobalContainer>
          <StyledPerks>
            <StyledPerkItem data-sal="slide-right" data-sal-delay="100" data-sal-duration="400">
              <h2>
                <strong>Dbamy o naszych</strong> gości
              </h2>
              <p>
                Wierzymy, że do wymyślenia rzeczy wielkich potrzebna jest odpowiednia przestrzeń, która pozwoli skupić się na tym co najważniejsze. Dlatego stworzyliśmy przyjazne środowisko, które sprawi, że Twoja praca stanie się przyjemna i efektywna.
              </p>
            </StyledPerkItem>
          {perks.map((item) =>
            <StyledPerkItem key={item.id} data-sal="slide-up" data-sal-delay={item.delay} data-sal-duration="400">
              <StyledPerkItemIcon>
                <Image filename={"perks/" + item.icon } alt={item.name} />
              </StyledPerkItemIcon>
              <StyledPerkItemTitle>{ item.name }</StyledPerkItemTitle>
              <StyledPerkItemDescription>{ item.description }</StyledPerkItemDescription>
            </StyledPerkItem>
          )}
          </StyledPerks>
        </GlobalContainer>
      </GlobalSection>
    )
  }
}
export default LandingPerks
